// Заглушки для страницы «Статистика».
// Всё, что здесь лежит, потом заменяется данными из API — форма объектов
// намеренно простая, чтобы маппинг с бэкенда был в одном месте.

export const KPI_CARDS = [
  {
    id: 'revenue',
    title: 'Общий оборот',
    value: '54 230 MDL',
    delta: '+12%',
    trend: 'up',
    caption: 'Рост в этом месяце',
    hint: 'Оборот за последние 6 месяцев',
  },
  {
    id: 'customers',
    title: 'Активные клиенты',
    value: '2 350',
    delta: '+5.2%',
    trend: 'up',
    caption: 'Высокое удержание',
    hint: 'Вовлечённость выше плана',
  },
  {
    id: 'orders',
    title: 'Всего заказов',
    value: '1 247',
    delta: '-2.1%',
    trend: 'down',
    caption: 'Снижение на 2% за период',
    hint: 'Объём заказов требует внимания',
  },
  {
    id: 'conversion',
    title: 'Конверсия',
    value: '3.24%',
    delta: '+8.3%',
    trend: 'up',
    caption: 'Стабильный рост',
    hint: 'Соответствует прогнозу',
  },
];

export const SALES_PERFORMANCE = [
  { month: 'Янв', sales: 12400, target: 14000 },
  { month: 'Фев', sales: 18200, target: 15000 },
  { month: 'Мар', sales: 16800, target: 16000 },
  { month: 'Апр', sales: 21500, target: 18000 },
  { month: 'Май', sales: 22100, target: 19500 },
  { month: 'Июн', sales: 26800, target: 22000 },
  { month: 'Июл', sales: 28400, target: 24000 },
  { month: 'Авг', sales: 27900, target: 25500 },
  { month: 'Сен', sales: 31200, target: 27000 },
  { month: 'Окт', sales: 33800, target: 29000 },
  { month: 'Ноя', sales: 37500, target: 32000 },
  { month: 'Дек', sales: 41200, target: 33500 },
];

export const SALES_PERIODS = [
  { value: '12m', label: 'Последние 12 мес.' },
  { value: '6m', label: 'Последние 6 мес.' },
  { value: '30d', label: 'Последние 30 дней' },
];

export const REVENUE_BREAKDOWN = [
  { id: 'subscriptions', name: 'Подписки', value: 24500, share: 45, color: '#2563eb' },
  { id: 'one-time', name: 'Разовые продажи', value: 16300, share: 30, color: '#10b981' },
  { id: 'services', name: 'Услуги', value: 8200, share: 15, color: '#f59e0b' },
  { id: 'partnerships', name: 'Партнёрства', value: 5400, share: 10, color: '#a855f7' },
];

export const RECENT_TRANSACTIONS = [
  {
    id: 'tx-1',
    name: 'Olivia Martin',
    email: 'olivia.martin@email.com',
    amount: '1 999,00 MDL',
    status: 'completed',
    time: '2 часа назад',
  },
  {
    id: 'tx-2',
    name: 'Jackson Lee',
    email: 'jackson.lee@email.com',
    amount: '2 999,00 MDL',
    status: 'pending',
    time: '5 часов назад',
  },
  {
    id: 'tx-3',
    name: 'Isabella Nguyen',
    email: 'isabella.nguyen@email.com',
    amount: '39,00 MDL',
    status: 'completed',
    time: '1 день назад',
  },
  {
    id: 'tx-4',
    name: 'William Kim',
    email: 'will@email.com',
    amount: '299,00 MDL',
    status: 'failed',
    time: '2 дня назад',
  },
  {
    id: 'tx-5',
    name: 'Sofia Davis',
    email: 'sofia.davis@email.com',
    amount: '99,00 MDL',
    status: 'completed',
    time: '3 дня назад',
  },
];

export const TRANSACTION_STATUS_LABELS = {
  completed: 'выполнена',
  pending: 'в обработке',
  failed: 'ошибка',
};

export const TOP_PRODUCTS = [
  { id: 1, name: 'Премиум-подписка', tag: 'Подписка', rating: 4.8, sales: 2847, revenue: '142 350 MDL', delta: '+23%', stock: 145, stockMax: 300 },
  { id: 2, name: 'Расширенная аналитика', tag: 'Инструменты', rating: 4.6, sales: 1923, revenue: '96 150 MDL', delta: '+18%', stock: 67, stockMax: 300 },
  { id: 3, name: 'Пакет услуг «Мобильный»', tag: 'Мобильные', rating: 4.9, sales: 1456, revenue: '72 800 MDL', delta: '+12%', stock: 234, stockMax: 300 },
  { id: 4, name: 'Корпоративная лицензия', tag: 'Бизнес', rating: 4.7, sales: 892, revenue: '178 400 MDL', delta: '+8%', stock: 12, stockMax: 300 },
  { id: 5, name: 'Базовая подписка', tag: 'Подписка', rating: 4.4, sales: 3421, revenue: '68 420 MDL', delta: '+31%', stock: 299, stockMax: 300 },
];

export const CUSTOMER_GROWTH = [
  { month: 'Янв', newCustomers: 240, returning: 890, churned: 60 },
  { month: 'Фев', newCustomers: 310, returning: 920, churned: 65 },
  { month: 'Мар', newCustomers: 285, returning: 1020, churned: 52 },
  { month: 'Апр', newCustomers: 455, returning: 1165, churned: 78 },
  { month: 'Май', newCustomers: 520, returning: 1280, churned: 61 },
  { month: 'Июн', newCustomers: 634, returning: 1445, churned: 55 },
];

export const CUSTOMER_DEMOGRAPHICS = [
  { id: '18-24', label: '18–24', value: 18 },
  { id: '25-34', label: '25–34', value: 34 },
  { id: '35-44', label: '35–44', value: 27 },
  { id: '45-54', label: '45–54', value: 14 },
  { id: '55+', label: '55+', value: 7 },
];

export const CUSTOMER_REGIONS = [
  { id: 'chisinau', label: 'Кишинёв', value: 48 },
  { id: 'balti', label: 'Бельцы', value: 17 },
  { id: 'cahul', label: 'Кагул', value: 11 },
  { id: 'orhei', label: 'Орхей', value: 9 },
  { id: 'other', label: 'Другие районы', value: 15 },
];

export const KEY_METRICS = [
  { id: 'total', icon: 'trending-up', label: 'Всего клиентов', value: '15 847', delta: '+12.5% к прошлому месяцу' },
  { id: 'retention', icon: 'users', label: 'Удержание', value: '92.4%', delta: '+2.1% улучшение' },
  { id: 'ltv', icon: 'credit-card', label: 'Средний LTV', value: '2 847 MDL', delta: '+8.3% рост' },
];
